"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Ordering_1 = require("fp-ts/lib/Ordering");
var Option_1 = require("fp-ts/lib/Option");
var Ord_1 = require("fp-ts/lib/Ord");
var setoid_utils_1 = require("./setoid.utils");
var isBefore = require("date-fns/is_before");
var Setoid_1 = require("fp-ts/lib/Setoid");
var OrdUtils;
(function (OrdUtils) {
    var setoidDate = setoid_utils_1.SetoidUtils.setoidDate;
    var SortDirection;
    (function (SortDirection) {
        SortDirection[SortDirection["Asc"] = 0] = "Asc";
        SortDirection[SortDirection["Desc"] = 1] = "Desc";
    })(SortDirection = OrdUtils.SortDirection || (OrdUtils.SortDirection = {}));
    function invertSortDirection(sortDirection) {
        switch (sortDirection) {
            case SortDirection.Desc:
                return SortDirection.Asc;
            case SortDirection.Asc:
                return SortDirection.Desc;
        }
    }
    OrdUtils.invertSortDirection = invertSortDirection;
    function getCompareWithDirection(compare) {
        var asc = compare;
        var desc = function (y, x) { return compare(x, y); };
        return function (direction) {
            switch (direction) {
                case SortDirection.Asc: {
                    return asc;
                }
                case SortDirection.Desc: {
                    return desc;
                }
            }
        };
    }
    OrdUtils.getCompareWithDirection = getCompareWithDirection;
    /**
     * @deprecated use fp-ts
     */
    OrdUtils.compareByKey = function (compare) { return function (key) { return function (a, b) { return compare(a[key], b[key]); }; }; };
    /**
     * @deprecated use fp-ts
     */
    OrdUtils.compareString = Ord_1.ordString.compare;
    /**
     * @deprecated use fp-ts
     */
    OrdUtils.compareNumber = Ord_1.ordNumber.compare;
    /**
     * @deprecated use fp-ts
     */
    OrdUtils.compareDate = function (a, b) { return (isBefore(a, b) ? -1 : 1); };
    /**
     * @deprecated use fp-ts
     */
    OrdUtils.compareOption = function (compare, defaultOrdering) {
        if (defaultOrdering === void 0) { defaultOrdering = 0; }
        return function (aOpt, bOpt) {
            return aOpt.foldL(function () { return defaultOrdering; }, function (a) { return bOpt.foldL(function () { return Ordering_1.invert(defaultOrdering); }, function (b) { return compare(a, b); }); });
        };
    };
    /**
     * @deprecated use fp-ts
     */
    OrdUtils.compareOptionNumber = OrdUtils.compareOption(Ord_1.ordNumber.compare);
    /**
     * @deprecated use fp-ts
     */
    OrdUtils.compareOptionString = OrdUtils.compareOption(Ord_1.ordString.compare);
    /**
     * @deprecated use fp-ts
     */
    OrdUtils.ordDate = __assign({}, setoidDate, { compare: OrdUtils.compareDate });
    /**
     * @deprecated use fp-ts
     */
    OrdUtils.ordOptionString = __assign({}, Option_1.getSetoid(Setoid_1.setoidString), { compare: OrdUtils.compareOptionString });
    /**
     * @deprecated use fp-ts
     */
    OrdUtils.ordOptionNumber = __assign({}, Option_1.getSetoid(Setoid_1.setoidNumber), { compare: OrdUtils.compareOptionNumber });
    /**
     * @deprecated use fp-ts
     */
    OrdUtils.compareOptionDate = OrdUtils.compareOption(OrdUtils.compareDate, -1);
})(OrdUtils = exports.OrdUtils || (exports.OrdUtils = {}));
